module.exports = __webpack_public_path__ + "nunito-sans-latin-300italic.1a3d2422361712bf569edf8b2e1f6d90.woff";